import React, { useState, useEffect, useRef } from "react";

import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import {
  AppLayout,
  BreadcrumbGroup,
  HelpPanel,
  Button,
  Box,
  Select,
  Spinner,
  Checkbox,
  SpaceBetween,
  Container,
  Header,
  Icon,
  SegmentedControl,
  Grid,
  Input,
  FormField,
  ColumnLayout,
  Modal,
  FileInput,
  FileUpload,
  Table,
  StatusIndicator
} from "@amzn/awsui-components-react";
import axios from "axios";

import SideNav from "./SideNav";
import appSettings from "./app_settings";

import { teamNames } from "./Constants";

import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as d3 from "d3";

import { setCurrentAppId } from "../../store/userAuthSlice";

import checkPageAccess from "../../checkPageAccess";
import AccessDenied from "../../AccessDenied";
import WaitForPageAccess from "../../WaitForPageAccess";

import { Auth, Amplify, Storage } from "aws-amplify";
import {Board, BoardItem} from "@amzn/awsui-board-components";
import { boardI18nStrings, boardItemI18nStrings } from 'src/i18n-strings/board-I18nStrings';

const BoffinSupplierMasterListOverride = (props) => {
  const userId = useSelector((globalState) => globalState.auth.userId);
  const history = useHistory();
  const currentAppId = useSelector(
    (globalState) => globalState.auth.currentAppId
  );
  const isCurrentAppAuthorised = useSelector(
    (globalState) => globalState.auth.isCurrentAppAuthorized
  );
  const [addOrUpdateModal, setAddOrUpdateModal] = useState(false)
  const [addStatus, setAddStatus] = useState(false);
  const [isItemSelected, setIsItemSelected] = useState(false)
  const [isCheckingAccess, setIsCheckingAccess] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState();
  const dispatch = useDispatch();
  const gridRef = useRef();
  const [dsInfo, setDsInfo] = useState([]);
  const [showLoadingIcon, setShowLoadingIcon] = useState(false);
  const [showUpdatingIcon, setShowUpdatingIcon] = useState(false);
  const [updateStatus, setUpdateStatus] = useState("");
  const [toolsHide, setToolsHide] = useState(true);
  const [selectedTeamName, setSelectedTeamName] = useState({});
  const [isAWS, setIsAWS] = useState(false);

  const [selectedItem, setSelectedItem] = useState([]);
  const [boardItems, setBoardItems] = useState([
    { id: "1", rowSpan: 5, columnSpan: 6,data:{}}
  ]);

  const [vendorNumber, setVendorNumber] = useState()
  const [vendorName, setVendorName] = useState()
  const [assetBook, setAssetBook] = useState()
  const [majorCat, setMajorCat] = useState()
  const [minorCat, setMinorCat] = useState()
  const [ledgerName, setLedgerName] = useState()
  const [slBook, setSlBook] = useState()
  const [ranking, setRanking] = useState()
  const [selectedAssetBook, setSelectedAssetBook] = useState({ label: "", value: ""})
  const [selectedMajorCat, setSelectedMajorCat] = useState({ label: "", value: ""})
  const [selectedMinorCat, setSelectedMinorCat] = useState({ label: "", value: ""})

  const [UELDs, setUELDs] = useState([])
  const [booksDS, setBooksDS] = useState([])
  const [majorCatsDropdown, setMajorCatsDropdown] = useState([])
  const [minorCatsDropdown, setMinorCatsDropdown] = useState([])
  const [booksDropdown, setBooksDropdown] = useState([])
  const [selectedSegmentId, setSelectedSegmentId] = useState("add");
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false)
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [bulkUploadMessage, setBulkUploadMessage] = useState(null);
  const [bulkColumnsList, setBulkColumnsList] = useState([]);
  const [bulkDsInfo, setBulkDsInfo] = useState([]);
  const [disableBulkUploadButton, setDisableBulkUploadButton] = useState(true);

  const bulkUploadKeys = ['vendor_number','vendor_name','asset_book','major_category','minor_category','LEDGER_NAME']

  useEffect(() => {
    if (currentAppId !== appSettings.appId) {
      dispatch(setCurrentAppId(appSettings.appId));
    }
    setIsAuthorized(isCurrentAppAuthorised);
    if (isCurrentAppAuthorised) {
      LoadData();
    }
    return () => {
      // this now gets called when the component unmounts
    };
  }, [isCurrentAppAuthorised]);

  useEffect(() => {
    if(isAuthorized === true || isAuthorized === false){
      setIsCheckingAccess(!isCheckingAccess);
    } 
  }, [isAuthorized]);

  useEffect(() => {
    if (uploadedFiles?.length > 0) {
      cleanUpBulkUploadInfo()
      if (uploadedFiles?.length > 1) {
        setBulkUploadMessage({ message: "Please upload only one file at a time.", messageType: 'error' })
        setDisableBulkUploadButton(true)
      } else {
        const file = uploadedFiles[0];
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const uint8Array = new Uint8Array(e.target.result);
            let csvText = '';

            // Try different encodings in order of preference
            const encodings = ['utf-8', 'gbk', 'gb2312', 'big5', 'shift-jis', 'iso-8859-1'];

            for (const encoding of encodings) {
              try {
                const decoder = new TextDecoder(encoding, { fatal: true });
                csvText = decoder.decode(uint8Array);
                // If no error thrown, this encoding worked
                break;
              } catch (err) {
                // Try next encoding
                continue;
              }
            }

            // If all encodings failed, use UTF-8 with replacement characters
            if (!csvText) {
              const decoder = new TextDecoder('utf-8', { fatal: false });
              csvText = decoder.decode(uint8Array);
            }

            const result = d3.csvParse(csvText);
            setBulkDsInfo(result);
            setDisableBulkUploadButton(false)
            let headers = [...bulkUploadKeys]
            if (result?.columns) {
              const definitions = result?.columns.map(colName => {
                headers = headers.filter(item => item !== colName)
                return {
                  id: colName,
                  header: colName,
                  cell: item => item[colName] || '-'
                }
              })

              definitions.push({
                id: 'stage',
                header: 'status',
                cell: item => <StatusIndicator type={item?.['stage']?.['messageType'] || 'pending'}>{item['stage']?.['message'] || 'Pending'}</StatusIndicator>
              })

              setBulkColumnsList(definitions)
            }

            if (headers.length > 0) {
              setBulkUploadMessage({ message: `Mandatory columns not available. ${headers}`, messageType: 'error' })
              setDisableBulkUploadButton(true)
            }
          } catch (error) {
            setBulkUploadMessage({ message: `Error reading file: ${error.message}. Please ensure the file is saved with UTF-8 encoding.`, messageType: 'error' });
            setDisableBulkUploadButton(true);
            return;
          }
        };

        // Try reading as ArrayBuffer first to handle encoding issues
        reader.readAsArrayBuffer ? reader.readAsArrayBuffer(file) : reader.readAsText(file, 'UTF-8');
      }
    }
  }, [uploadedFiles]);

  const breadItems = [
    { text: "Home", href: "/Home" },
    { text: "ATeam BI", href: "/ATeamBIHome" },
    { text: "Boffin", href: "/BoffinHome" },
    { text: "Supplier Master List Override", href: "/" },
  ];

  const onFollowHandler = (ev) => {
    ev.preventDefault();
    if (ev.detail.href) {
      history.push(ev.detail.href.substring(1));
    }
  };

  useEffect(() => {

    const book_type_codes = [... new Set(booksDS.map((row) => row.BOOK_TYPE_CODE))];
    const maj_cats = [... new Set(UELDs.map((row) => row.majorcategory))];
    const min_cats = [... new Set(UELDs.map((row) => row.minorcategory))];

    //console.log(UELDs)

    setBooksDropdown (book_type_codes.map((item) => (
      { label: item, value: item}
    )))

    setMajorCatsDropdown (maj_cats.map((item) => (
      { label: item, value: item}
    )))

    setMinorCatsDropdown (min_cats.map((item) => (
      { label: item, value: item}
    )))


  },[UELDs, booksDS])

  const LoadData = async () => {
    setShowLoadingIcon(true);
    setIsItemSelected(false);
    // console.log('Need to execute sql here..')

    let folder = "Boffin/datasets/";
    let fn = folder + "Category_EUL_Mapping.csv";
    const fileURL = await Storage.get(fn, { level: "public", expires: 60 });
    let csvdata = await d3.csv(fileURL).then((result) => {
      setUELDs(result);
      // setState here..
    });

    let mSQL1 = "SELECT * FROM boffin.mapping_book_type_ledger;";
    let body1 =
      `{
          "processName" : "MySQL",
          "scriptName"  : "executeSQLonMySQL",
          "parameters"  : {"sql":"` +
      mSQL1 +
      `"}
        }`;


    let mSQL =
      "SELECT * FROM boffin.supplier_master_list_override;";
    let body =
      `{
          "processName" : "MySQL",
          "scriptName"  : "executeSQLonMySQL",
          "parameters"  : {"sql":"` +
      mSQL +
      `"}
        }`;

    // console.log(body)
    const ApiGateWayEndpoint = Amplify.Cache.config.ApiGateWayEndpoint;
    let url = ApiGateWayEndpoint + "/executeOnDemand";

    axios
      .post(url, body1, {
        headers: {
          Authorization: (await Auth.currentSession())
            .getIdToken()
            .getJwtToken(),
        },
      })
      .then((response) => {
        //console.log(response.data.data)
        setBooksDS(response.data.data);
      })
      .catch((error) => {
      });

    axios
      .post(url, body, {
        headers: {
          Authorization: (await Auth.currentSession())
            .getIdToken()
            .getJwtToken(),
        },
      })
      .then((response) => {
        //console.log(response.data.data)
        setDsInfo(response.data.data);
        setShowLoadingIcon(false);
      })
      .catch((error) => {
      });



  };

  const resetBulkUploadInfo = () => {
    cleanUpBulkUploadInfo()
    setShowBulkUploadModal(false)
    setDisableBulkUploadButton(true)
  }

  const cleanUpBulkUploadInfo = () => {
    setBulkUploadMessage(null)
    setBulkColumnsList([])
    setBulkDsInfo([])
    setUploadedFiles([])
  }

  const bulkUpload = () => {
    cleanUpBulkUploadInfo()
    setShowBulkUploadModal(true)
  }

  const escapeSqlValue = (value) => {
    return value ? value.toString().replace(/'/g, "''") : '';
  }

  const processBulkUpload = async () => {
    setDisableBulkUploadButton(true)
    setBulkUploadMessage({ message: "Uploading data. Do not navigate out of the screen until all the rows are completely processed.", messageType: 'warning' })
    for (let i in bulkDsInfo) {
      let row = bulkDsInfo[i]
      if (row['LEDGER_NAME'] && row['vendor_number'] && row['vendor_name']) {
        bulkDsInfo[i]['stage'] = { message: 'Processing', messageType: 'in-progress' }
        setBulkDsInfo([...bulkDsInfo])
        try {
          let query = `DELETE FROM boffin.supplier_master_list_override WHERE (UPPER(LEDGER_NAME) = '${escapeSqlValue(row['LEDGER_NAME'])}' AND vendor_number = '${escapeSqlValue(row['vendor_number'])}' AND vendor_name = '${escapeSqlValue(row['vendor_name'])}');`
          let response = await alterRecord(query)
          query = `INSERT into boffin.supplier_master_list_override (vendor_number, vendor_name, asset_book, major_category, minor_category, LEDGER_NAME) VALUES ('${escapeSqlValue(row['vendor_number'])}','${escapeSqlValue(row['vendor_name'])}', '${escapeSqlValue(row['asset_book'] || ' ')}','${escapeSqlValue(row['major_category'] || ' ')}','${escapeSqlValue(row['minor_category'] || ' ')}','${escapeSqlValue(row['LEDGER_NAME'])}');`
          response = await alterRecord(query)
          bulkDsInfo[i]['stage'] = { message: 'Success', messageType: 'success' }
          setBulkDsInfo([...bulkDsInfo])
        } catch (error) {
          bulkDsInfo[i]['stage'] = { message: `Failed. ${error?.message || error}`, messageType: 'error' }
          setBulkDsInfo([...bulkDsInfo])
        }
      } else {
        bulkDsInfo[i]['stage'] = { message: 'Mandatory fields not provided. vendor_number, vendor_name and LEDGER_NAME are mandatory.', messageType: 'error' }
        setBulkDsInfo([...bulkDsInfo])
      }
    }

    setBulkUploadMessage({ message: "Bulk upload completed", messageType: 'success' })
    setDisableBulkUploadButton(false)

  }

  const alterRecord = async (query) => {
    let body =
      `{
          "processName" : "MySQL",
          "scriptName"  : "executeSQLonMySQL",
          "parameters"  : {"sql":"` +
      query +
      `"}
        }`;

    // console.log(query)

    const ApiGateWayEndpoint = Amplify.Cache.config.ApiGateWayEndpoint;
    let url = ApiGateWayEndpoint + "/executeOnDemand";
    let response = await axios
      .post(url, body, {
        headers: {
          Authorization: (await Auth.currentSession())
            .getIdToken()
            .getJwtToken(),
        },
      })
    return response

  }
  
  const addRecord = async () => {

   
    if (!(vendorNumber && vendorName && assetBook && 
      majorCat && minorCat && ledgerName)) {
      setAddOrUpdateModal(true)
      return;
    }
    setShowUpdatingIcon(true)

    let mSQL =
      "INSERT into boffin.supplier_master_list_override (vendor_number, vendor_name, asset_book, major_category, minor_category, LEDGER_NAME) VALUES ('" +
      vendorNumber +
      "', '" +
      vendorName +
      "', '" +
      assetBook +
      "', '" +
      majorCat +
      "', '" +
      minorCat +
      "', '" +
      ledgerName +
      "');";

    let body =
      `{
          "processName" : "MySQL",
          "scriptName"  : "executeSQLonMySQL",
          "parameters"  : {"sql":"` +
      mSQL +
      `"}
        }`;

    // console.log(body)
    const ApiGateWayEndpoint = Amplify.Cache.config.ApiGateWayEndpoint;
    let url = ApiGateWayEndpoint + "/executeOnDemand";
    axios
      .post(url, body, {
        headers: {
          Authorization: (await Auth.currentSession())
            .getIdToken()
            .getJwtToken(),
        },
      })
      .then((response) => {
      
          setShowUpdatingIcon(false);
          setAddStatus(true);
          LoadData();
          setVendorNumber()
          setVendorName()
          setAssetBook()
          setSelectedAssetBook()
          setMajorCat()
          setSelectedMajorCat()
          setMinorCat()
          setSelectedMinorCat()
          setLedgerName()
          setSlBook()
          setRanking()
      });

  };

  const updateRecord = async () => {
    if (!(vendorNumber && vendorName && assetBook && 
      majorCat && minorCat && ledgerName)) {
      setAddOrUpdateModal(true)
      return;
    }
    setShowUpdatingIcon(true)
    let mSQL =
      "UPDATE boffin.supplier_master_list_override SET asset_book = '" +
      assetBook +
      "', major_category = '" +
      majorCat +
      "', minor_category = '" +
      minorCat +
      "' WHERE vendor_number ='" +
      vendorNumber +
      "' AND vendor_name ='" +
      vendorName +
      "' AND LEDGER_NAME ='" +
      ledgerName +
      "';";

    let body =
      `{
          "processName" : "MySQL",
          "scriptName"  : "executeSQLonMySQL",
          "parameters"  : {"sql":"` +
      mSQL +
      `"}
        }`;

    // console.log(body)
    const ApiGateWayEndpoint = Amplify.Cache.config.ApiGateWayEndpoint;
    let url = ApiGateWayEndpoint + "/executeOnDemand";
    axios
      .post(url, body, {
        headers: {
          Authorization: (await Auth.currentSession())
            .getIdToken()
            .getJwtToken(),
        },
      })
      .then((response) => {
        //  console.log(response.data.records)
          setShowUpdatingIcon(false);
          setUpdateStatus(true);
          LoadData();
          setVendorNumber()
          setVendorName()
          setAssetBook()
          setMajorCat()
          setMinorCat()
          setLedgerName()
          setSelectedAssetBook({ label: "", value: ""})
          setSelectedMajorCat({ label: "", value: ""})
          setSelectedMinorCat({ label: "", value: ""})

      });
  };

  const defaultColDef = {
    // set filtering on for all columns
    filter: true,
    filterParams: {
      buttons: ["reset"],
      debounceMs: 200,
    },
  };

  const columnDefs = [
    {
      field: "vendor_number",
      width: "150px",
      resizable: true,
      sortable: true,
      headerName: "vendor_number",
    },
    {
      field: "vendor_name",
      width: "250px",
      sortable: true,
      resizable: true,
      headerName: "vendor_name",
    },
    {
      field: "LEDGER_NAME",
      width: "250px",
      sortable: true,
      resizable: true,
      headerName: "LEDGER_NAME",
    },
    {
      field: "asset_book",
      width: "250px",
      sortable: true,
      resizable: true,
      headerName: "asset_book",
    },
    {
      field: "major_category",
      width: "250px",
      sortable: true,
      resizable: true,
      headerName: "major_category",
    },
    {
        field: "minor_category",
        width: "250px",
        sortable: true,
        resizable: true,
        headerName: "minor_category",
    },
    
  ];
  const onSelectionChanged= () =>{
    const selectedRows = gridRef.current.api.getSelectedRows();
    if(selectedRows.length > 0) {

      setSelectedSegmentId("edit")
      setIsItemSelected(true)
  
      setVendorNumber(selectedRows[0].vendor_number)
      setVendorName(selectedRows[0].vendor_name)
      setAssetBook(selectedRows[0].asset_book)
      setMajorCat(selectedRows[0].major_category)
      setMinorCat(selectedRows[0].minor_category)
      setLedgerName(selectedRows[0].LEDGER_NAME)

      setSelectedAssetBook({ label: selectedRows[0].asset_book, value: selectedRows[0].asset_book})
      setSelectedMajorCat({ label: selectedRows[0].major_category, value: selectedRows[0].major_category})
      setSelectedMinorCat({ label: selectedRows[0].minor_category, value: selectedRows[0].minor_category})
    } else {

      setIsItemSelected(false)
      setVendorNumber()
      setVendorName()
      setAssetBook()
      setMajorCat()
      setMinorCat()
      setLedgerName()

      setSelectedAssetBook({ label: "", value: ""})
      setSelectedMajorCat({ label: "", value: ""})
      setSelectedMinorCat({ label: "", value: ""})

    }
  }

  const downloadFileClick = () => {
    gridRef?.current?.api?.exportDataAsCsv({
      fileName: 'supplier_master_list_override.csv',
    });
  }


  const helpContent = (
    <HelpPanel
      header={
        <div>
          <h2>Add new Record / Edit existing record</h2>
        </div>
      }
    >
      <Container>
        <Box>
          <SegmentedControl
            selectedId={selectedSegmentId}
            onChange={({ detail }) => {
              setSelectedSegmentId(detail.selectedId)
              if (detail.selectedId === 'add') {
                gridRef.current.api.deselectAll()
              }
            }}
            options={[
              { text: "Add New Record", id: "add", iconName: "add-plus" },
              { text: "Edit Existing Record", id: "edit", iconName: "edit" },
            ]}
          />
        </Box>

        {selectedSegmentId === "add" ? (<>
        <Box>
                  <ColumnLayout columns={2}>
                    <FormField label="Vendor Number">
                      <Input
                        type="number"
                        value={vendorNumber}
                        onChange={({ detail }) => setVendorNumber(detail.value)}
                      ></Input>
                    </FormField>
                    <FormField label="Vendor Name">
                      <Input
                        type="text"
                        value={vendorName}
                        onChange={({ detail }) => setVendorName(detail.value)}
                        ariaRequired
                      ></Input>
                    </FormField>
                    <FormField label="Asset Book">
                      {/* <Input
                type="text"
                value={assetBook}
                onChange={({ detail }) => setAssetBook(detail.value)}
              ></Input> */}

                      <Select
                        selectedOption={selectedAssetBook}
                        options={booksDropdown}
                        onChange={({ detail }) => {
                          setSelectedAssetBook(detail.selectedOption);
                          setAssetBook(detail.selectedOption.value)
                        }}
                        virtualScroll
                      ></Select>
                    </FormField>
                    <FormField label="Major Category">
                      {/* <Input
                type="text"
                value={majorCat}
                onChange={({ detail }) => setMajorCat(detail.value)}
              ></Input> */}
                      <Select
                        selectedOption={selectedMajorCat}
                        options={majorCatsDropdown}
                        onChange={({ detail }) => {
                          setSelectedMajorCat(detail.selectedOption);
                          setMajorCat(detail.selectedOption.value)
                        }}
                        virtualScroll
                      ></Select>
                    </FormField>
                    <FormField label="Minor Category">
                      {/* <Input
                type="text"
                value={minorCat}
                onChange={({ detail }) => setMinorCat(detail.value)}
              ></Input> */}
                      <Select
                        selectedOption={selectedMinorCat}
                        options={minorCatsDropdown}
                        onChange={({ detail }) => {
                          setSelectedMinorCat(detail.selectedOption);
                          setMinorCat(detail.selectedOption.value)
                        }}
                        virtualScroll
                      ></Select>
                    </FormField>
                    <FormField label="Ledger Name">
                      <Input
                        type="text"
                        value={ledgerName}
                        onChange={({ detail }) => setLedgerName(detail.value)}
                      ></Input>
                    </FormField>
                    {/* <FormField label="SL Book">
              <Input
                type="text"
                value={slBook}
                onChange={({ detail }) => setSlBook(detail.value)}
              ></Input>
            </FormField>
            <FormField label="Ranking">
              <Input
                type="number"
                value={ranking}
                onChange={({ detail }) => setRanking(detail.value)}
              ></Input>
            </FormField> */}
                  </ColumnLayout>
                </Box>
                <br />
                <SpaceBetween direction="horizontal" size="m">
                  <Button variant='primary' iconName="edit" onClick={() => addRecord()}>Add</Button>
                <Button variant='primary' iconName="edit" onClick={() => bulkUpload()}>Bulk upload</Button>
                </SpaceBetween>
                <Box>
                  {showUpdatingIcon ? (
                    <Box>
                      {" "}
                      <Spinner></Spinner> Adding...{" "}
                    </Box>
                  ) : (
                    <Box>

                    </Box>
                  )}
                </Box>
        </>) : (
          <>
            {
              (isItemSelected) ? <>
                <Box>
                  <ColumnLayout columns={2}>
                    <FormField label="Vendor Number">
                      <Input
                        type="number"
                        value={vendorNumber}
                        onChange={({ detail }) => setVendorNumber(detail.value)}
                        disabled
                      ></Input>
                    </FormField>
                    <FormField label="Vendor Name">
                      <Input
                        type="text"
                        value={vendorName}
                        onChange={({ detail }) => setVendorName(detail.value)}
                        ariaRequired
                        disabled
                      ></Input>
                    </FormField>
                    <FormField label="Asset Book">
                      {/* <Input
                type="text"
                value={assetBook}
                onChange={({ detail }) => setAssetBook(detail.value)}
              ></Input> */}

                      <Select
                        selectedOption={selectedAssetBook}
                        options={booksDropdown}
                        onChange={({ detail }) => {
                          setSelectedAssetBook(detail.selectedOption);
                          setAssetBook(detail.selectedOption.value)
                        }}
                        virtualScroll
                      ></Select>
                    </FormField>
                    <FormField label="Major Category">
                      {/* <Input
                type="text"
                value={majorCat}
                onChange={({ detail }) => setMajorCat(detail.value)}
              ></Input> */}
                      <Select
                        selectedOption={selectedMajorCat}
                        options={majorCatsDropdown}
                        onChange={({ detail }) => {
                          setSelectedMajorCat(detail.selectedOption);
                          setMajorCat(detail.selectedOption.value)
                        }}
                        virtualScroll
                      ></Select>
                    </FormField>
                    <FormField label="Minor Category">
                      {/* <Input
                type="text"
                value={minorCat}
                onChange={({ detail }) => setMinorCat(detail.value)}
              ></Input> */}
                      <Select
                        selectedOption={selectedMinorCat}
                        options={minorCatsDropdown}
                        onChange={({ detail }) => {
                          setSelectedMinorCat(detail.selectedOption);
                          setMinorCat(detail.selectedOption.value)
                        }}
                        virtualScroll
                      ></Select>
                    </FormField>
                    <FormField label="Ledger Name">
                      <Input
                        type="text"
                        value={ledgerName}
                        onChange={({ detail }) => setLedgerName(detail.value)}
                        disabled
                      ></Input>
                    </FormField>
                    {/* <FormField label="SL Book">
              <Input
                type="text"
                value={slBook}
                onChange={({ detail }) => setSlBook(detail.value)}
              ></Input>
            </FormField>
            <FormField label="Ranking">
              <Input
                type="number"
                value={ranking}
                onChange={({ detail }) => setRanking(detail.value)}
              ></Input>
            </FormField> */}
                  </ColumnLayout>
                </Box>
                <br />
                <Button variant='primary' iconName="edit" onClick={() => updateRecord()}>Update</Button>
                <Box>
                  {showUpdatingIcon ? (
                    <Box>
                      {" "}
                      <Spinner></Spinner> Updating...{" "}
                    </Box>
                  ) : (
                    <Box>

                    </Box>
                  )}
                </Box>
              </>
                :
                <Box variant="awsui-key-label">Select a row to edit and update.</Box>
            }
          </>
        )
        }
    </Container>
  </HelpPanel>
  );

  const content = (
    <div>
      {isAuthorized ? (
        <Box>
          {showLoadingIcon ? (
            <Box>
              <Spinner></Spinner>
              <Box>Loading...</Box>
              <Box>Please wait, takes upto a minute...</Box>
            </Box>
          ) : (
            <Box>
              <Container
                header={
                  <Header
                    actions={
                      <SpaceBetween direction="horizontal" size="xs">
                          <Button
                            iconName="download"
                            onClick={() => downloadFileClick()}
                          >
                            Download
                          </Button>
                          <Button
                            variant="normal"
                            iconName="refresh"
                            onClick={() => LoadData()}
                          >
                            Refresh
                        </Button>
                        </SpaceBetween>
                    }
                  >
                    Supplier Master List Override         
                  </Header>
                }
              >
                <Board
                  renderItem={(item) => (
                      <BoardItem i18nStrings={boardItemI18nStrings}>
                        <div
                          className="ag-theme-alpine"
                          style={{ height: "92%", width: "100%" }}
                        >
                          <AgGridReact
                            ref={gridRef}
                            rowData={dsInfo}
                            defaultColDef={defaultColDef}
                            columnDefs={columnDefs}
                            rowSelection="single"
                            animateRows={true}
                            rowHeight={30}
                            onSelectionChanged={onSelectionChanged}
                            enableCellTextSelection={true}
                            rowMultiSelectWithClick={true}
                          ></AgGridReact>
                        </div>
                      </BoardItem>
                  )}
                  onItemsChange={(event) => setBoardItems(event.detail.items)}
                  items={boardItems}
                  i18nStrings={boardI18nStrings}
                />
              </Container>
            </Box>
          )}
          <Modal
            onDismiss={() => resetBulkUploadInfo()}
            visible={showBulkUploadModal}
            footer={
              <Box float="right">
                <SpaceBetween direction="horizontal" size="xs">
                  {
                    bulkUploadMessage && bulkUploadMessage?.message && <StatusIndicator type={bulkUploadMessage?.['messageType'] || 'pending'}>{bulkUploadMessage?.['message']}</StatusIndicator>
                  }
                  {
                    bulkDsInfo?.length > 0 && <Button variant="primary" onClick={processBulkUpload} disabled={disableBulkUploadButton}>upload</Button>
                  }
                  <Button variant="link" onClick={resetBulkUploadInfo}>Cancel</Button>
                </SpaceBetween>
              </Box>
            }
            header="Bulk upload vendor list"
            size='max'
          >
            <SpaceBetween direction="vertical" size="m">
              <FileUpload
                accept=".csv"
                onChange={({ detail }) => setUploadedFiles(detail.value)}
                value={uploadedFiles}
                i18nStrings={{
                  uploadButtonText: e =>
                    e ? "Choose files" : "Choose file",
                  dropzoneText: e =>
                    e
                      ? "Drop files to upload"
                      : "Drop file to upload",
                  removeFileAriaLabel: e =>
                    `Remove file ${e + 1}`,
                  limitShowFewer: "Show fewer files",
                  limitShowMore: "Show more files",
                  errorIconAriaLabel: "Error",
                  warningIconAriaLabel: "Warning"
                }}
                showFileLastModified
                showFileSize
                showFileThumbnail
                tokenLimit={3}
                constraintText="Hint text for file requirements"
              />

              {
                bulkUploadMessage && bulkUploadMessage?.message && <StatusIndicator type={bulkUploadMessage?.['messageType'] || 'pending'}>{bulkUploadMessage?.['message']}</StatusIndicator>
              }

              {
                bulkColumnsList?.length > 0 && <Table
                  columnDefinitions={bulkColumnsList}
                  items={bulkDsInfo}
                  stickyHeader={true}
                  resizableColumns={true}
                >
                </Table>
              }
            </SpaceBetween>
          </Modal>

           <Modal
            visible={addOrUpdateModal}
            header={<div>Error</div>}
            onDismiss={() => {
              setAddOrUpdateModal(false)
            }}
            >
              All Fields are required
          </Modal>
          <Modal
            visible={addStatus}
            header={<div>Info</div>}
            onDismiss={() => {
              setAddStatus(false)
            }}
            >
            <Icon variant="success" name="status-positive"></Icon>
            Record Added!
          </Modal>
          <Modal
            visible={updateStatus}
            header={<div>Info</div>}
            onDismiss={() => {
              setUpdateStatus(false)
            }}
            >
            <Icon variant="success" name="status-positive"></Icon>
            Record Updated!
          </Modal>
        </Box>
      ) : isCheckingAccess ? (
        <div>
          <WaitForPageAccess></WaitForPageAccess>
        </div>
      ) : (
        <div>
          <AccessDenied appName={appSettings.appName}></AccessDenied>
        </div>
      )}
    </div>
  );

  return (
    <AppLayout
      breadcrumbs={
        <BreadcrumbGroup
          items={breadItems}
          onFollow={(event) => onFollowHandler(event)}
        ></BreadcrumbGroup>
      }
      content={content}
      navigation={<SideNav activeHref="/BoffinSupplierMasterListOverride" />}
      headerSelector="#TopBar"
      navigationHide={false}
      toolsWidth={550}
      tools={isAuthorized ? helpContent : ''}
      toolsOpen={toolsHide}
      maxContentWidth = {Number.MAX_VALUE}
      onToolsChange={()=>{setToolsHide(!toolsHide)}}
      headerVariant="high-contrast"
    ></AppLayout>
  );
};

export default BoffinSupplierMasterListOverride;
